"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deal = void 0;
const types_1 = require("../../types");
const { DealEnum } = types_1.Vehicle;
exports.deal = [
    {
        id: DealEnum.Great,
        name: 'Great Deal',
    },
    {
        id: DealEnum.Good,
        name: 'Good Deal',
    },
    {
        id: DealEnum.Fair,
        name: 'Fair Deal',
    },
    {
        id: DealEnum.Bad,
        name: 'High Priced',
    },
    {
        id: DealEnum.Low,
        name: 'Low Priced',
    }
];
